// @core/api/endpoints/form/archive_form.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ArchiveFormRequest,
  FormResponse,
} from '../../../types/form';

const BASE_PATH = '/form';

/**
 * Archive form
 * Archives a form. Archived forms no longer accept submissions but data is preserved.
 */
export async function ArchiveForm(
  form_id: string,
  data: ArchiveFormRequest,
  options?: RequestOptions
): Promise<FormResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/forms/:form_id/archive`;
  requestPath = requestPath.replace(':form_id', encodeURIComponent(form_id));
  const requestOptions = options;
  return client.post<FormResponse>(requestPath, data, requestOptions);
}
